import * as React from 'react'
import * as Recharts from 'recharts'

interface Props {
  data: any
  key1: string
  key2: string
  alternativeColors: boolean
}

export class Chart extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
  }

  public override render(): React.ReactNode {
    const upperStroke = this.props.alternativeColors ? '#D4901A' : '#2F97E6'
    const upperFill = this.props.alternativeColors ? '#EDB739' : '#80C8FF'
    const sort = () => 1
    return (
      <Recharts.AreaChart width={730} height={180} data={this.props.data}>
        <Recharts.XAxis
          dataKey="name"
          height={24}
          tick={{fill: '#AAB1C4', fontSize: 14, transform: 'translate(0, 4)'}}
        />
        <Recharts.YAxis
          width={24}
          tick={{fill: '#AAB1C4', fontSize: 14, transform: 'translate(-4, 0)'}}
        />
        <Recharts.CartesianGrid strokeDasharray="3 3" />
        <Recharts.Tooltip itemSorter={sort} animationDuration={300} />
        <Recharts.Area
          isAnimationActive={false}
          type="monotone"
          dataKey={this.props.key1}
          stackId="1"
          stroke="#4BAE03"
          fill="#61CC14"
        />
        <Recharts.Area
          isAnimationActive={false}
          type="monotone"
          dataKey={this.props.key2}
          stackId="1"
          stroke={upperStroke}
          fill={upperFill}
        />
      </Recharts.AreaChart>
    )
  }
}
